import { motion } from "framer-motion";
import { MaskedLines } from "./Reveal";

export default function PageHero({ eyebrow, lines, copy, image }) {
  return (
    <section className="relative overflow-hidden border-b border-line" data-testid="page-hero">
      <div className="absolute inset-0">
        {image && (
          <motion.img
            src={image}
            alt=""
            initial={{ scale: 1.12, opacity: 0 }}
            animate={{ scale: 1, opacity: 0.32 }}
            transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
            className="h-full w-full object-cover"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-ink/40" />
        <div className="blueprint-grid absolute inset-0 opacity-40" />
      </div>
      <div className="relative mx-auto max-w-7xl px-4 pb-20 pt-36 sm:px-8 sm:pb-28 sm:pt-44 lg:px-16">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15, duration: 0.6 }}
          className="font-mono text-[11px] uppercase tracking-[0.35em] text-fog"
        >
          {eyebrow}
        </motion.p>
        <h1 className="mt-5 font-display text-4xl font-black uppercase leading-[0.98] tracking-tight sm:text-5xl lg:text-6xl">
          <MaskedLines lines={lines} baseDelay={0.3} />
        </h1>
        {copy && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.7 }}
            className="mt-6 max-w-2xl text-sm leading-relaxed text-mist sm:text-base"
          >
            {copy}
          </motion.p>
        )}
      </div>
    </section>
  );
}
